// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
:root {
  --hot-gradient: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
  --warm-gradient: linear-gradient(135deg, #ffd166 0%, #ffe066 100%);
  --cold-gradient: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  --total-gradient: linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%);
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-hot: #ff6b6b;
  --color-warm: #ffd166;
  --color-cold: #4facfe;
  --color-active: #48bb78;
  --color-pending: #ed8936;
  --color-inactive: #a0aec0;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Main Container */
.EmpList-container {
  min-height: 100vh;
  background: var(--color-bg-secondary);
  font-family: var(--font-primary);
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Container */
.EmpList-header-container {
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
}

.EmpList-title {
  /* font-size: 1.75rem;
  font-weight: 700;
  color: var(--color-text-primary);
  position: relative;
  margin: 0; */

  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.empBtn {
  display: flex;
  gap: 10px;
}
/* Controls */
.EmpList-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-wrap: wrap;
}

.EmpList-search-form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  max-width: 300px;
}

.EmpList-search-label {
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.EmpList-searchInput {
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  background: var(--color-bg-primary);
  transition: all var(--transition-normal);
  font-family: var(--font-primary);
  width: 250px;
}

.EmpList-searchInput:focus {
  outline: none;
  border-color: #6a11cb;
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.EmpList-searchInput::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.7;
}

.EmpList-viewModeSelect {
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-family: var(--font-primary);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.EmpList-viewModeSelect:focus {
  outline: none;
  border-color: #6a11cb;
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.EmpList-markAttendance {
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  border: none;
  /* background: var(--primary-gradient); */
  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
  color: white;
  box-shadow: var(--shadow-sm);
  font-family: var(--font-primary);
  background: #4b0082;
}
.employeEmail {
  border: 2px solid #4b0082;
  padding: 5px;
  border-radius: 50px;
}

.EmpList-markAttendance:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.EmpList-markAttendance:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Table View */
.EmpList-table-wrapper {
  overflow-x: auto;
  margin-bottom: 2rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  margin-top: 1rem;
}

.EmpList-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
}

.EmpList-table th {
  background: #f3f4f6;
}

.EmpList-table th,
.EmpList-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
  font-size: 0.95rem;
}

.EmpList-table th {
  background: var(--color-bg-secondary);
  font-weight: 600;
  color: var(--color-text-primary);
  text-transform: uppercase;
  font-size: 0.9rem;
}

.EmpList-table td {
  color: var(--color-text-secondary);
}

/* .EmpList-table tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.02);
} */

.EmpList-table tr:hover {
  background: #f9fafb;
}

.EmpList-table th:nth-child(1),
.EmpList-table td:nth-child(1) {
  width: 10%;
}

.EmpList-table th:nth-child(2),
.EmpList-table td:nth-child(2) {
  width: 15%;
}

.EmpList-table th:nth-child(3),
.EmpList-table td:nth-child(3) {
  width: 20%;
}

.EmpList-table th:nth-child(4),
.EmpList-table td:nth-child(4) {
  width: 12%;
}

.EmpList-table th:nth-child(5),
.EmpList-table td:nth-child(5) {
  width: 15%;
}

.EmpList-table th:nth-child(6),
.EmpList-table td:nth-child(6) {
  width: 10%;
}

.EmpList-table th:nth-child(7),
.EmpList-table td:nth-child(7) {
  width: 10%;
}

.EmpList-table th:nth-child(8),
.EmpList-table td:nth-child(8) {
  width: 15%;
}

.EmpList-table th:nth-child(9),
.EmpList-table td:nth-child(9) {
  width: 13%;
}

.EmpList-statusSelect {
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.85rem;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-family: var(--font-primary);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.EmpList-statusSelect:focus {
  outline: none;
  border-color: #6a11cb;
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.1);
}

.EmpList-statusSelect:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.EmpList-statusUpdating {
  margin-left: 0.5rem;
  font-size: 0.85rem;
  color: var(--color-text-secondary);
}

/* Card View */
.EmpList-cardGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.EmpList-card {
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
  padding: 1.5rem;
  transition: all var(--transition-normal);
}

.EmpList-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.EmpList-cardTitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 1rem;
}

.EmpList-card p {
  font-size: 0.95rem;
  color: var(--color-text-secondary);
  margin-bottom: 0.5rem;
}

.EmpList-card p strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

/* Empty State */
.EmpList-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 2rem;
}

.EmpList-empty-state-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 1rem;
}

.EmpList-empty-state-icon svg {
  width: 100%;
  height: 100%;
  stroke: var(--color-text-secondary);
}

/* Print Styles */
@media print {
  .EmpList-header-container,
  .EmpList-empty-state {
    display: none;
  }

  .EmpList-container {
    background: none;
    padding: 0;
  }

  .EmpList-table-wrapper,
  .EmpList-table {
    max-width: 100%;
  }

  .EmpList-table th,
  .EmpList-table td {
    padding: 0.5rem;
    font-size: 0.8rem;
    border: 1px solid #000;
  }

  .EmpList-table tr:nth-child(even),
  .EmpList-table tr:hover {
    background: none;
  }

  .EmpList-statusSelect,
  .EmpList-statusUpdating {
    display: none;
  }

  .EmpList-cardGrid {
    display: none;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .EmpList-container {
    padding: 1.5rem;
  }

  .EmpList-header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }

  .EmpList-title {
    font-size: 1.5rem;
    text-align: center;
  }

  .EmpList-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .EmpList-search-form {
    max-width: 100%;
  }

  .EmpList-viewModeSelect,
  .EmpList-markAttendance {
    width: 100%;
    text-align: center;
  }

  .EmpList-table th,
  .EmpList-table td {
    padding: 0.75rem;
    font-size: 0.85rem;
  }

  .EmpList-card {
    padding: 1rem;
  }

  .EmpList-cardTitle {
    font-size: 1.1rem;
  }

  .EmpList-card p {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .EmpList-container {
    padding: 1rem;
  }

  .EmpList-title {
    font-size: 1.25rem;
  }

  .EmpList-searchInput,
  .EmpList-viewModeSelect,
  .EmpList-markAttendance {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  .EmpList-table th,
  .EmpList-table td {
    padding: 0.5rem;
    font-size: 0.8rem;
  }

  .EmpList-statusSelect {
    font-size: 0.8rem;
  }

  .EmpList-cardTitle {
    font-size: 1rem;
  }

  .EmpList-card p {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Attendance/EmpList.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,iEAAiE;EACjE,kEAAkE;EAClE,kEAAkE;EAClE,mEAAmE;EACnE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE;;;;cAIY;;EAEZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,yCAAyC;EACzC,mEAAmE;EACnE,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;sCACoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Base Styles */\n:root {\n  --hot-gradient: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);\n  --warm-gradient: linear-gradient(135deg, #ffd166 0%, #ffe066 100%);\n  --cold-gradient: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  --total-gradient: linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%);\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-hot: #ff6b6b;\n  --color-warm: #ffd166;\n  --color-cold: #4facfe;\n  --color-active: #48bb78;\n  --color-pending: #ed8936;\n  --color-inactive: #a0aec0;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Main Container */\n.EmpList-container {\n  min-height: 100vh;\n  background: var(--color-bg-secondary);\n  font-family: var(--font-primary);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Header Container */\n.EmpList-header-container {\n  /* display: flex; */\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.EmpList-title {\n  /* font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  position: relative;\n  margin: 0; */\n\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.empBtn {\n  display: flex;\n  gap: 10px;\n}\n/* Controls */\n.EmpList-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  flex-wrap: wrap;\n}\n\n.EmpList-search-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 300px;\n}\n\n.EmpList-search-label {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.EmpList-searchInput {\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  background: var(--color-bg-primary);\n  transition: all var(--transition-normal);\n  font-family: var(--font-primary);\n  width: 250px;\n}\n\n.EmpList-searchInput:focus {\n  outline: none;\n  border-color: #6a11cb;\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.EmpList-searchInput::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n}\n\n.EmpList-viewModeSelect {\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  font-family: var(--font-primary);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.EmpList-viewModeSelect:focus {\n  outline: none;\n  border-color: #6a11cb;\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.EmpList-markAttendance {\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  border: none;\n  /* background: var(--primary-gradient); */\n  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */\n  color: white;\n  box-shadow: var(--shadow-sm);\n  font-family: var(--font-primary);\n  background: #4b0082;\n}\n.employeEmail {\n  border: 2px solid #4b0082;\n  padding: 5px;\n  border-radius: 50px;\n}\n\n.EmpList-markAttendance:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.EmpList-markAttendance:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Table View */\n.EmpList-table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 2rem;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.EmpList-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-md);\n}\n\n.EmpList-table th {\n  background: #f3f4f6;\n}\n\n.EmpList-table th,\n.EmpList-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n  font-size: 0.95rem;\n}\n\n.EmpList-table th {\n  background: var(--color-bg-secondary);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  font-size: 0.9rem;\n}\n\n.EmpList-table td {\n  color: var(--color-text-secondary);\n}\n\n/* .EmpList-table tr:nth-child(even) {\n  background: rgba(0, 0, 0, 0.02);\n} */\n\n.EmpList-table tr:hover {\n  background: #f9fafb;\n}\n\n.EmpList-table th:nth-child(1),\n.EmpList-table td:nth-child(1) {\n  width: 10%;\n}\n\n.EmpList-table th:nth-child(2),\n.EmpList-table td:nth-child(2) {\n  width: 15%;\n}\n\n.EmpList-table th:nth-child(3),\n.EmpList-table td:nth-child(3) {\n  width: 20%;\n}\n\n.EmpList-table th:nth-child(4),\n.EmpList-table td:nth-child(4) {\n  width: 12%;\n}\n\n.EmpList-table th:nth-child(5),\n.EmpList-table td:nth-child(5) {\n  width: 15%;\n}\n\n.EmpList-table th:nth-child(6),\n.EmpList-table td:nth-child(6) {\n  width: 10%;\n}\n\n.EmpList-table th:nth-child(7),\n.EmpList-table td:nth-child(7) {\n  width: 10%;\n}\n\n.EmpList-table th:nth-child(8),\n.EmpList-table td:nth-child(8) {\n  width: 15%;\n}\n\n.EmpList-table th:nth-child(9),\n.EmpList-table td:nth-child(9) {\n  width: 13%;\n}\n\n.EmpList-statusSelect {\n  padding: 0.25rem 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.85rem;\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  font-family: var(--font-primary);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.EmpList-statusSelect:focus {\n  outline: none;\n  border-color: #6a11cb;\n  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.1);\n}\n\n.EmpList-statusSelect:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.EmpList-statusUpdating {\n  margin-left: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--color-text-secondary);\n}\n\n/* Card View */\n.EmpList-cardGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.EmpList-card {\n  background: var(--color-bg-primary);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-md);\n  padding: 1.5rem;\n  transition: all var(--transition-normal);\n}\n\n.EmpList-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.EmpList-cardTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 1rem;\n}\n\n.EmpList-card p {\n  font-size: 0.95rem;\n  color: var(--color-text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.EmpList-card p strong {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n/* Empty State */\n.EmpList-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 2rem;\n}\n\n.EmpList-empty-state-icon {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 1rem;\n}\n\n.EmpList-empty-state-icon svg {\n  width: 100%;\n  height: 100%;\n  stroke: var(--color-text-secondary);\n}\n\n/* Print Styles */\n@media print {\n  .EmpList-header-container,\n  .EmpList-empty-state {\n    display: none;\n  }\n\n  .EmpList-container {\n    background: none;\n    padding: 0;\n  }\n\n  .EmpList-table-wrapper,\n  .EmpList-table {\n    max-width: 100%;\n  }\n\n  .EmpList-table th,\n  .EmpList-table td {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n    border: 1px solid #000;\n  }\n\n  .EmpList-table tr:nth-child(even),\n  .EmpList-table tr:hover {\n    background: none;\n  }\n\n  .EmpList-statusSelect,\n  .EmpList-statusUpdating {\n    display: none;\n  }\n\n  .EmpList-cardGrid {\n    display: none;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .EmpList-container {\n    padding: 1.5rem;\n  }\n\n  .EmpList-header-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1.5rem;\n  }\n\n  .EmpList-title {\n    font-size: 1.5rem;\n    text-align: center;\n  }\n\n  .EmpList-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .EmpList-search-form {\n    max-width: 100%;\n  }\n\n  .EmpList-viewModeSelect,\n  .EmpList-markAttendance {\n    width: 100%;\n    text-align: center;\n  }\n\n  .EmpList-table th,\n  .EmpList-table td {\n    padding: 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .EmpList-card {\n    padding: 1rem;\n  }\n\n  .EmpList-cardTitle {\n    font-size: 1.1rem;\n  }\n\n  .EmpList-card p {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .EmpList-container {\n    padding: 1rem;\n  }\n\n  .EmpList-title {\n    font-size: 1.25rem;\n  }\n\n  .EmpList-searchInput,\n  .EmpList-viewModeSelect,\n  .EmpList-markAttendance {\n    padding: 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .EmpList-table th,\n  .EmpList-table td {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n\n  .EmpList-statusSelect {\n    font-size: 0.8rem;\n  }\n\n  .EmpList-cardTitle {\n    font-size: 1rem;\n  }\n\n  .EmpList-card p {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
